import { modalState } from '@/state/modal.state';

import { ConfirmDeleteModal } from '../confirm-delete-modal';

import { useDeleteCompanyFile } from './use-delete-company-file.mutation';
import { useAtomValue } from 'jotai';

export const DeleteCompanyFileModal = () => {
  const modal = useAtomValue(modalState);
  const { deleteCompanyFile } = useDeleteCompanyFile();

  if (!modal || modal.state !== 'deleteCompanyFile') return null;

  return (
    <ConfirmDeleteModal
      onConfirm={deleteCompanyFile.bind(null, modal.file.id)}
    />
  );
};
